import { render, staticRenderFns } from "./verify-icon.vue?vue&type=template&id=0398a9d3&scoped=true"
import script from "./verify-icon.vue?vue&type=script&lang=js"
export * from "./verify-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0398a9d3",
  null
  
)

export default component.exports